export const addIndex = (array, index, newValue) => [
  ...array.slice(0, index + 1),
  newValue,
  ...array.slice(index + 1)
];

export const replaceIndex = (array, index, newValue) => [
  ...array.slice(0, index),
  newValue,
  ...array.slice(index + 1)
];

export const deleteIndex = (array, index) => [
  ...array.slice(0, index),
  ...array.slice(index + 1)
];

export const replaceObjectKey = (obj, oldKey, newKey) => {
  const { [oldKey]: deleted, ...objWithOldKeyDeleted } = obj;
  return {
    ...objWithOldKeyDeleted,
    [newKey]: obj[oldKey]
  };
};

export const zipObject = (keysAndValues, initialObj = {}) =>
  Array.isArray(keysAndValues[0])
    ? keysAndValues.reduce(
        (obj, keyAndValue) => ({ ...obj, [keyAndValue[0]]: keyAndValue[1] }),
        initialObj
      )
    : keysAndValues.reduce(
        (obj, keyAndValue) => ({
          ...obj,
          [keyAndValue.key]: keyAndValue.value
        }),
        initialObj
      );

export const allKeysHaveValues = (obj) =>
  Object.keys(obj).every((key) => !!obj[key]);

export const distinct = (array) => [...new Set(array)];
